import { Package } from "lucide-react";
import type { ObjectAssetInfo } from "../../api";
import { useModelThumbnail } from "../../hooks/useModelThumbnail";

export function ModelThumbnail({ model }: { model: ObjectAssetInfo }) {
  const cached = useModelThumbnail(model.id);

  return (
    <div className="absolute inset-0 overflow-hidden bg-sands-100">
      {cached ? (
        <img
          src={cached}
          alt={model.name}
          className="h-full w-full object-contain"
          draggable={false}
        />
      ) : (
        <div className="flex h-full w-full items-center justify-center">
          <Package className="h-5 w-5 text-sands-400" />
        </div>
      )}
    </div>
  );
}
